export default __webpack_public_path__ + "static/media/dominic.4c72b988.jpeg";